import type { ModeReglementsPointageType } from '@/types';

import * as MODES_REGLEMENTS from './modeReglement';

const RECU = {
  numeroRecu: 'N° de reçu',
  dateRecu: 'Date',
  nomPayeur: 'Nom du payeur',
};

const PAIEMENT_EN_LIGNE = {
  datePaiement: 'Date de transaction',
  ...RECU,
  montant: 'Montant',
};

/**
 * Colonnes de l'export CSV du pointage des règlements, par mode : clé du règlement aplati par
 * `formatReglementsPointageToCsv` → libellé, repris des en-têtes du tableau. L'ordre des clés est
 * celui des colonnes du fichier.
 */
export const COLONNES_CSV_POINTAGE: Record<ModeReglementsPointageType, Record<string, string>> = {
  [MODES_REGLEMENTS.CHEQUE]: {
    ...RECU,
    numero: 'N° de chèque',
    banque: 'Banque',
    tireur: 'Nom du tireur',
    montant: 'Montant',
  },
  [MODES_REGLEMENTS.NUMERAIRE]: { ...RECU, montant: 'Montant' },
  [MODES_REGLEMENTS.CESU]: {
    ...RECU,
    nombre: 'Nombre de chèques',
    dateValidite: 'Date de validité',
    montant: 'Montant',
  },
  [MODES_REGLEMENTS.CHEQUE_VAC]: {
    ...RECU,
    nombre: 'Nombre de chèques',
    dateValidite: 'Date de validité',
    montant: 'Montant',
  },
  [MODES_REGLEMENTS.CARTE_BANCAIRE]: { ...RECU, numero: 'N° du ticket', montant: 'Montant' },
  [MODES_REGLEMENTS.VIREMENT]: {
    numeroRecu: RECU.numeroRecu,
    dateRecu: RECU.dateRecu,
    montant: 'Montant',
  },
  [MODES_REGLEMENTS.PRELEVEMENT]: {
    ...RECU,
    tireur: 'Titulaire du compte',
    datePrelevement: 'Date prélèvement',
    montant: 'Montant',
  },
  [MODES_REGLEMENTS.CARTE_BANCAIRE_INTERNET]: PAIEMENT_EN_LIGNE,
  [MODES_REGLEMENTS.PRELEVEMENT_INTERNET]: PAIEMENT_EN_LIGNE,
  [MODES_REGLEMENTS.TICKET]: {
    ...RECU,
    type: 'Type',
    nombre: 'Nombre',
    montantUnitaire: 'Montant unitaire',
    dateValidite: 'Date de validité',
    montant: 'Montant',
  },
  [MODES_REGLEMENTS.BON_CCAS]: {
    ...RECU,
    numero: 'N°',
    dateValidite: 'Date de validité',
    montant: 'Montant',
  },
  [MODES_REGLEMENTS.BON_CAF]: {
    ...RECU,
    nombre: 'Nombre',
    dateValidite: 'Date de validité',
    montant: 'Montant',
  },
};
